/*
 * ELASTICSEARCH CONFIDENTIAL
 * __________________
 *
 *  Copyright Elasticsearch B.V. All rights reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Elasticsearch B.V. and its suppliers, if any.
 * The intellectual and technical concepts contained herein
 * are proprietary to Elasticsearch B.V. and its suppliers and
 * may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright
 * law.  Dissemination of this information or reproduction of
 * this material is strictly forbidden unless prior written
 * permission is obtained from Elasticsearch B.V.
 */

/** @jsx jsx */
import { jsx, css } from '@emotion/react'

import { EuiFlexGroup, EuiFlexItem, useEuiTheme } from '@elastic/eui'

import CopyButton from '@modules/cui/CopyButton'

import type { FunctionComponent, ReactElement } from 'react'

type Props = {
  title: ReactElement
  description: ReactElement
  endpoint: string
}

const RemoteClusterLink: FunctionComponent<Props> = ({ title, description, endpoint }) => {
  const { euiTheme } = useEuiTheme()

  const headingStyles = css({
    borderRight: `2px solid ${euiTheme.colors.lightShade}`, // $euiColorLightShade
    maxWidth: '10rem',
  })

  return (
    <EuiFlexGroup alignItems='center'>
      <EuiFlexItem css={headingStyles}>
        <CopyButton color='primary' value={endpoint}>
          {title}
        </CopyButton>
      </EuiFlexItem>
      <EuiFlexItem>{description}</EuiFlexItem>
    </EuiFlexGroup>
  )
}

export default RemoteClusterLink
